import { arSA } from '@clerk/localizations/ar-SA';
import { enUS } from '@clerk/localizations/en-US';
import overrides from './clerk-ar-overrides.json';

// Official Arabic resources leave some authentication fields/errors undefined.
// Fill those strings without changing Clerk's workflow or mutating its bundle.
const arabic: typeof arSA = JSON.parse(JSON.stringify(arSA));
for (const [key, value] of Object.entries(overrides)) {
  const parts = key.split('.');
  let target = arabic as Record<string, unknown>;
  for (const part of parts.slice(0, -1)) {
    target[part] ??= {};
    target = target[part] as Record<string, unknown>;
  }
  target[parts[parts.length - 1]] = value;
}

export const clerkLocalizations = { ar: arabic, en: enUS };
